import _ from 'lodash'
import BaseViewModel from '../../../infraestructure/BaseViewModel'
import AdvisoryCity from '../models/AdvisoryCity'

export default class AdvisoryCityViewModel extends BaseViewModel {
  constructor(view) {
    super(view)
  }
  // INICIALIZADORES

  //#region CRUD

  onCreate() {
    let item = new AdvisoryCity({
      state: "create",
      status: 1
    });
    return item;
  }

  onDelete(data) {
    let item = new AdvisoryCity(data);
    item.state = "delete";
    return item;
  }

  onEdit(data) {
    let item = new AdvisoryCity(data);
    item.state = "update";
    return item;
  }

  onSearchCollection() {
    return this.api.advisoryCities.find(this.getSearchQuery())
  }

  mapCollection(collection) {
    return _.map(collection, (data) => new AdvisoryCity(data));
  }

  onSearchItem(id) {
    return this.api.advisoryCities.findOne(id)
  }

  onSave(data) {
    if (data.state === 'create')
      return this.api.advisoryCities.create(data.toSend())
    else
      return this.api.advisoryCities.update(data.id, data.toSend());
  }

  onDestroy(context, id) {
    context.api.advisoryCities.delete(id)
      .then(response => context.view.onSuccess(response.data))
      .catch(context.view.onError)
  }

  onCancel(context) {
    context.view.item = null;
  }

  import(file) {
    this.api.advisoryCities.import(file)
      .then(response => this.view.onImportResponse(response.data))
      .catch(this.view.onError)
  }

  exportToExcel() {
    this.api.advisoryCities.exportToExcel()
      .then(response => this.view.onExportResponse(response.data))
      .catch(this.view.onError)
  }

  // #endregion

  // #region BINDING DATA

  bindFormView() {
    if (this.view.formData.state === 'update') {
      this.api.roles.find()
        .then((response) => {
          this.view.roles = [this.view.formData.role]
        })
        .catch(this.view.onError); 
    }
  }

  // #endregion

  // #region QUERIES

  /**
   * Metodo para buscar categorias de cursos
   * @param {String} data Query string para parametros de búsqueda
   */
  findCourseCategories(data) {
    this.api.advisoryCities.find(data)
      .then((response) => this.view.onSearchCourseCategoriesResponse(response.data.data))
      .catch(this.view.onError)
  }
  

  // #endregion

  //#region MAPPING DATA

  
  // #endregion

  // #region VALIDATIONS

  // #endregion
}
